import { Pipe, PipeTransform, inject } from '@angular/core';
import { BrandSocialMediaCode } from '@web/shared/module/brand';
import { SvgIcon } from '@web/shared/ui';
import { BrandSocialMediaIconProviderService } from '../providers/brand-social-media-icon-provider.service';
import { Observable, of } from 'rxjs';
import { isNil, Nillable } from '@web/utils';

@Pipe({
  name: 'brandSocialMediaIconByCode',
  standalone: true,
})
export class BrandSocialMediaIconByCodePipe implements PipeTransform {
  private readonly provider = inject(BrandSocialMediaIconProviderService);

  public transform(
    code: Nillable<BrandSocialMediaCode>,
  ): Observable<Nillable<SvgIcon>> {
    if (isNil(code)) {
      return of(code);
    }

    return this.provider.icon(code);
  }
}
